import React from 'react';
import { FilterForm, useFilterFormActions } from './filter-form';
import { FormControlLabel, Radio, TextField } from '@material-ui/core';
import { QPStatementType } from '@pages/quotes-policies/quotes-policies.enums';

export const BooleanFilters = props => (
  <FilterForm {...props} radioFilters={BooleanFilterFormItems} />
);

function BooleanFilterFormItems({ setRadioFilter, radioValue, column }) {
  const { handleInputClick, form, getRadioValue } = useFilterFormActions(
    radioValue,
    setRadioFilter
  );

  if (column.id == 'statement_type') {
    return (
      <>
      {Object.values(QPStatementType).map((type) => (
        <FormControlLabel
          key={type}
          value={type}
          control={<Radio />}
          label={type}
          name="$eq"
          inputRef={form.register}
        />
      ))}
    </>
    );
  } 
}
